// Copyright © 2023 Move Closer
import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { AbstractAdBanner } from './AbstractAdBanner.ui';
let AdBannerWTG = class AdBannerWTG extends AbstractAdBanner {
    get hasValidConfig() {
        const isValid = !!this.module.content.adUnit;
        if (!isValid) {
            console.warn('[AdBanner] Invalid config', this.module.content);
            if (typeof this.onEmptyCallback === 'undefined') {
                this.onEmpty();
            }
            else {
                this.onEmptyCallback();
            }
        }
        return isValid;
    }
    get id() {
        if (!this.module.content.adUnitFullPath) {
            return '';
        }
        if (this.module.content.adUnitDivId) {
            return this.module.content.adUnitDivId;
        }
        return this.module.content.adUnitFullPath.replace(/[\s-/]/gi, '_');
    }
    waitForPubads(i = 20) {
        if (i === 0) {
            return Promise.reject(new Error('[AdBanner] googletag.pubads() not available'));
        }
        if (typeof googletag === 'undefined' || !('pubads' in googletag)) {
            return new Promise((resolve, reject) => {
                setTimeout(async () => {
                    this.waitForPubads(i - 1).then(resolve).catch(reject);
                }, 100);
            });
        }
        else {
            return Promise.resolve();
        }
    }
    initAdsEvent() {
        // console.debug('WTGAds')
        googletag.cmd.push(() => {
            googletag.pubads().addEventListener('slotRenderEnded', (event) => {
                const slotElementId = event.slot.getSlotElementId();
                const isCurrentBanner = !!this.bannerContainer && this.bannerContainer.querySelector('[id="' + slotElementId + '"]') !== null;
                if (isCurrentBanner) {
                    // console.log('[AdBanner] empty debug', this.id,event.isEmpty,this.shouldShrink)
                    if (event.isEmpty && this.shouldShrink) {
                        console.info('[AdBanner] empty ad', this.id);
                        return;
                    }
                    this.$nextTick(() => {
                        this.isEmpty = false;
                    });
                }
            });
        });
    }
};
AdBannerWTG = __decorate([
    Component({
        name: 'AdBannerWTG',
        async mounted() {
            try {
                await this.waitForPubads();
                this.initAdsEvent();
            }
            catch (e) {
                console.warn(e);
            }
        },
        template: `
    <section v-if="shouldDisplay && !hide && !forceHide" class="ad-banner module" ref="container"
             :class="[bannerSizeClass, bannerVersionClass, { invisible : isEmpty && this.shouldShrink }]"
             :style="resolvedSectionStyl">
    <div class="ad-banner__box" :style="resolvedContainerStyl">
      <header class="line-header ad-banner__header" :class="{'--light':!isDarkHeader,'--dark':isDarkHeader}">
        <div class="line-header__content text-ui-separator text-uppercase m-0 mt-4 mb-3 fw-normal">
          <span>{{ $t('_.ad') }}</span>
          <div class="ad-banner__close" @click="toggleHide" v-if="showCloseButton">
            <i class="icon-close"/>
          </div>
        </div>
      </header>
      <div v-if="elementId" class="ad-banner__box__inner" :id="elementId">
        <div :id="id" :data-code="module.content.adUnitFullPath" :data-add-unit="module.content.adUnitId"
             :data-add-sizes="JSON.stringify(module.content.sizes)"/>
      </div>
    </div>
    </section>
    <section v-else class="empty-div" ref="container"></section>
  `
    })
], AdBannerWTG);
export { AdBannerWTG };
